import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';

var Config = require('../../../config');

class ModalCancel extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);

		this.state = {
			show: false,
			id:"",
			cancel:false,
			delete:false,
            // Estado para el manejo de motivos
            motivo_key: "", 
            motivos_list: [] 
		}
	}

	componentDidMount(){
		this.props.onRef(this);
        this.getMotivos();
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

    // Carga los motivos usando el endpoint existente
    getMotivos(){
        fetch(Config.default.apiGateway.URL + 'lookups?type=REJECTION_PETITION_REASONS&option=actives&order=true', {
            method: 'get',
            headers: new Headers({
                'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
                'Accept': 'application/json'
            })
        })
        .then(res => res.json())
        .then(res => {
            if(res) this.setState({ motivos_list: res });
        })
        .catch(err => console.log(err));
    }

	handleShow(id){
		this.setState({show:true, id:id});
	}

	handleClose(){
		this.setState({show:false, id:"", cancel:false, delete:false, motivo_key: ""});
	}

	handleChange(e){
		if(e.target.name === 'delete'){
			this.setState({
				delete: e.target.checked ? true : false,
				cancel:false
			})
		}else if(e.target.name === 'cancel'){
			this.setState({
				delete: false,
				cancel:e.target.checked ? true : false,
			})
		} else {
            // Actualiza el motivo seleccionado
            this.setState({ [e.target.name]: e.target.value });
        }
	}

	handleSubmit(e){
		e.preventDefault();
		
        // Validación obligatoria del motivo
        if(!this.state.motivo_key){
            swal('Atención', 'Debe seleccionar un motivo', 'warning');
            return;
        }

		var url = "";
        const userId = sessionStorage.getItem("user_id");
        // Enviamos el 'key' del motivo y el usuario como query params
        const params = "?motivo_key=" + this.state.motivo_key + "&user_id=" + userId;

		if(this.state.delete){
			url = 'petitions/' + this.state.id + params;
		}else if(this.state.cancel){
			url = 'petitions/cancel/' + this.state.id + params;
		}else{
			swal('Error', 'Debe seleccionar una opción', 'error');
			return;
		}

		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+url, {
  			method : 'delete',
  			headers: new Headers({
  				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
  				'Accept'		: 'application/json',
  				'Content-Type'	: 'application/json'
  			})
  		}).then(res => {
  			this.props.waiting.handleClose();
  			if(res.ok){
  				if(this.props.getList != null){
  					this.props.getList();
  				}
  				// Mensaje personalizado según la acción
  				var msg = this.state.delete ? "El registro se eliminó correctamente" : "El registro se canceló correctamente";
				this.handleClose();
  				swal('Success', msg, 'success');
  			} else {
  				res.text().then((msg)=>{
  					swal("Error", msg, 'error');
  				})
  			}
  		});
	}

	render(){
		const {t} = this.props;
		return (
			<Modal bsSize="sm" show={this.state.show} onHide={this.handleClose}>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
		        			<div style={{color:'orange', textAlign:'center'}}>
				        		<i className="fa fa-exclamation fa-5x" aria-hidden="true"></i>
				        	</div>
		        		</div>
		        		<div className="col-xs-12" style={{textAlign:'center'}}>
		        			<h2>¿Está Seguro?</h2>
		        		</div>
		        		<div className="col-xs-12" style={{textAlign:'center'}}>
		        			<h4>Seleccione una opción</h4>
		        		</div>
		        		<div className="col-xs-12 col-sm-offset-2">
		        			<input type="checkbox" name="delete" id="delete" value={this.state.delete} onChange={this.handleChange}
		        				checked={this.state.delete} />
		        			<span style={{marginLeft:'8px'}}>Eliminar Petición</span>
		        		</div>
		        		<div className="col-xs-12 col-sm-offset-2">
		        			<input type="checkbox" name="cancel" id="cancel" value={this.state.cancel} onChange={this.handleChange}
		        				checked={this.state.cancel}/>
		        			<span style={{marginLeft:'8px'}}>Cancelar Petición</span>
		        		</div>

                        {/* SELECTOR DE MOTIVO - Usando 'key' como value */}
                        <div className="col-xs-12" style={{marginTop: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                            <b style={{color: 'red', marginRight: '10px'}}>MOTIVO</b>
                            <select 
                                name="motivo_key" 
                                className="form-control" 
                                style={{border: '2px solid red', width: '160px'}}
                                value={this.state.motivo_key}
                                onChange={this.handleChange}
                            >
                                <option value="">Seleccione...</option>
                                {this.state.motivos_list.map((m, i) => (
                                    <option key={i} value={m.key}>{m.name}</option> 
                                ))}
                            </select>
                        </div>

		        	</div>
		        </Modal.Body>
		        <Modal.Footer style={{textAlign:'center'}}>
		        	<FlatButton primary={true} label={t('content.generics.buttons.submit')}  onClick={this.handleSubmit}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		)
	}
}

export default translate('translations')(ModalCancel)